/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */

/** @module core/modules/array-utils/shuffle */

/**
 * @description Randomly shuffles input array elements.
 * @param {Array<*>} input - Input array.
 * @param {number} [times=1] - Number of times to shuffle.
 * @returns {Array<*>} Shuffled array.
 */
function shuffle(input, times) {
  var index = null;
  var randomIndex = null;
  times = typeof times === 'number' ? times : 1;

  for (var i = 0; i < times; i++) {
    index = input.length; // WHILE THERE ARE ELEMENTS TO SHUFFLE

    while (index > 0) {
      // PICK A REMAINING ELEMENT
      randomIndex = Math.floor(Math.random() * index); // SWAP IT WITH THE CURRENT ELEMENT

      var _ref = [input[randomIndex], input[index]];
      input[index] = _ref[0];
      input[randomIndex] = _ref[1];
      index--;
    }
  }

  return input;
}

export { shuffle };